var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "modal-container member-roster-unavailable-days-modal" },
    [
      _c("div", { staticClass: "modal-header" }, [
        _c("h4", { staticClass: "modal-title" }, [
          _vm._v("Update Unavailable Days"),
        ]),
        _c(
          "button",
          {
            staticClass:
              "md-button md-simple md-just-icon md-round modal-default-button md-theme-default",
            attrs: { type: "button" },
            on: {
              click: function ($event) {
                $event.stopPropagation()
                return _vm.$modal.hide()
              },
            },
          },
          [_vm._m(0)]
        ),
      ]),
      _c("div", { staticClass: "modal-body" }, [
        !_vm.selectedMemberIds.length
          ? _c("p", { staticClass: "no-selection" }, [
              _vm._v("No team members selected."),
            ])
          : _c("div", [
              _c("p", { staticClass: "selected-count" }, [
                _c("strong", [_vm._v(_vm._s(_vm.selectedMemberIds.length))]),
                _vm._v(
                  "\n                team member(s) selected.\n            "
                ),
              ]),
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c(
                    "md-datepicker",
                    {
                      attrs: { "md-immediately": true },
                      model: {
                        value: _vm.form.startDate,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "startDate", $$v)
                        },
                        expression: "form.startDate",
                      },
                    },
                    [_c("label", [_vm._v("Start")])]
                  ),
                  _vm.validation.startDate
                    ? _c("small", { staticClass: "md-error" }, [
                        _vm._v("Start date is required."),
                      ])
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c(
                    "md-datepicker",
                    {
                      attrs: { "md-immediately": true },
                      model: {
                        value: _vm.form.endDate,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "endDate", $$v)
                        },
                        expression: "form.endDate",
                      },
                    },
                    [_c("label", [_vm._v("End")])]
                  ),
                  _vm.validation.endDate
                    ? _c("small", { staticClass: "md-error" }, [
                        _vm._v("End date is required."),
                      ])
                    : _vm.validation.endBeforeStart
                    ? _c("small", { staticClass: "md-error" }, [
                        _vm._v(
                          "\n                    End date cannot be earlier than start date.\n                "
                        ),
                      ])
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c(
                    "md-field",
                    { class: { "md-invalid": _vm.validation.reason } },
                    [
                      _c("label", [_vm._v("Reason (optional)")]),
                      _c("md-input", {
                        attrs: { maxlength: "250" },
                        model: {
                          value: _vm.form.reason,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.form,
                              "reason",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "form.reason",
                        },
                      }),
                      _vm.validation.reason
                        ? _c("span", { staticClass: "md-error" }, [
                            _vm._v("Reason is required."),
                          ])
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "form-group attachments-group" },
                [
                  _c("label", [
                    _vm._v(
                      "\n                    Attachments\n                    "
                    ),
                    _c("span", { staticClass: "accepted-filetypes" }, [
                      _vm._v(
                        "(Allowed: " +
                          _vm._s(_vm.acceptedFileTypesComputed) +
                          ")"
                      ),
                    ]),
                  ]),
                  _c("document-file-upload", {
                    attrs: {
                      documents: _vm.attachments,
                      "file-label": "files or images",
                      "accepted-file-types": _vm.acceptedFileTypes,
                    },
                    on: { "upload-success": _vm.onAttachmentUpload },
                  }),
                ],
                1
              ),
              _vm.errorMessage
                ? _c(
                    "p",
                    {
                      staticClass: "md-error",
                      staticStyle: { "margin-top": "4px" },
                    },
                    [_vm._v(_vm._s(_vm.errorMessage))]
                  )
                : _vm._e(),
            ]),
      ]),
      _c(
        "div",
        { staticClass: "modal-footer" },
        [
          _c(
            "md-button",
            {
              staticClass: "dialog-button md-default",
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                  return _vm.$modal.hide($event)
                },
              },
            },
            [_vm._v("Close")]
          ),
          _c(
            "md-button",
            {
              staticClass: "dialog-button md-primary",
              attrs: {
                disabled: !_vm.isValid || _vm.isSubmitting,
                id: "btnConfirmUpdateUnavailableDays",
              },
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                  return _vm.submit($event)
                },
              },
            },
            [
              !_vm.isSubmitting
                ? _c("span", [_vm._v("Update")])
                : _c("span", [_vm._v("Saving...")]),
            ]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "md-ripple" }, [
      _c("div", { staticClass: "md-button-content" }, [
        _c("i", { staticClass: "md-icon md-icon-font md-theme-default" }, [
          _vm._v("clear"),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }